var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"checkbox-container"},[_c('label',{on:{"click":function($event){return _vm.toggle()}}},[_c('font-awesome-icon',{class:_vm.disabled ? 'disabled' : 'active',attrs:{"icon":_vm.value ? 'check-square' : 'square'}}),_vm._v(" "+_vm._s(_vm.title)+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }